<div class="procedure-info">
  <div class="subtitle">
    <div class="image-content">
      <img [src]="getOrganizationPhoto()" [alt]="'Logo de ' + (organization?.name || 'clínica')" />
    </div>
    <div class="nome">{{ organization?.name }}</div>
  </div>
  <div class="row">
    <div class="content proc">
      <div>
        <span class="service-name">{{ getProcedureDisplayName() }}</span>
      </div>

      <div class="content-actions">
        <button type="button" mat-button color="primary" (click)="openGoogleMapsLocation(); $event.stopPropagation()" [disabled]="!location?.mapUrl">
          <mat-icon>location_on</mat-icon>
          <span>Abrir no mapa</span>
        </button>
        <button type="button" mat-button color="primary" (click)="openOrganizationInfos(); $event.stopPropagation()">
          <mat-icon>info</mat-icon>
          <span>Sobre a clínica</span>
        </button>
      </div>
      <div class="endereco">{{ getLocation() }}</div>

      <div class="toggle-area">
        <div class="payment-summary">{{ getPaymentSummary() }}</div>

        <button type="button" mat-flat-button color="primary" class="btnVer" id="ver-{{ index }}" (click)="toggleHorarios(index)">
          <mat-icon>keyboard_arrow_down</mat-icon> Ver horários
        </button>
        <button type="button" mat-flat-button color="primary" class="btnFechar" id="fechar-{{ index }}" (click)="toggleHorarios(index)" style="display: none">
          <mat-icon>keyboard_arrow_up</mat-icon> Fechar
        </button>
      </div>
    </div>
  </div>
